import React, { useContext } from 'react';
import { func } from 'prop-types';
import { Redirect } from 'react-router-dom';
import AuthContext from '../../utils/auth-context';

export const withAdminRole = WrappedComponent => {
    return function AdminRole(props) {
        const { roles } = useContext(AuthContext);
        const { authUser } = props;

        if (roles && !roles.isAdmin) {
            if (authUser && Object.keys(authUser).length) {
                return <Redirect to="/" />;
            }
        }

        return <WrappedComponent {...props} />;
    };
};

withAdminRole.propTypes = {
    back: func,
};
export default withAdminRole;
